import React from 'react';

/**
 * Maturity Tooltip content
 */
const MaturityTooltip = (/** @type {{ isFisa?: boolean; enableUpdatedFisaCopy?: boolean }} */ {
    isFisa = false,
    enableUpdatedFisaCopy = false,
}) => {
    return (
        <>
            <h3>What does this mean?</h3>
            <ul>
                <li>
                    {isFisa
                        ? enableUpdatedFisaCopy
                            ? "We'll pay your balance including any interest earned into an Instant Access Cash ISA and close your Fixed Rate Cash ISA."
                            : "We'll pay your balance into an Instant Access Cash ISA and close your Fixed Rate Cash ISA. Interest will be paid into your linked account."
                        : "We'll automatically transfer your total balance, including your interest, back to your linked account on this date."
                    }
                </li>
            </ul>
        </>
    );
};

export default MaturityTooltip;
